<template>
  <div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { gmapApi } from 'vue2-google-maps'
import _ from 'lodash'

export default {
  data () {
    return {
      markers: {},
      isMarkerInitialized: false,
      isSoptsInitialized: false,
      markerCluster: {},
      sectedPlaceId: null,
      showFilter: {}
    }
  },
  methods: {
    isMapInitialized: function () {
      return !_.isEmpty(this.map) && this.google !== null && this.genres !== null && this.genres.length > 0
    },
    getVisible: function (genreIds) {
      const genre = this.genres.filter(g => genreIds.includes(g.id))
      const visible = genre.filter(g => this.filter[g.id])
      return visible.length > 0 ? true : false
    },
    setMarker: function () {
      if (this.isMapInitialized() && this.places !== null && !this.isMarkerInitialized) {
        this.isMarkerInitialized = true
        this.genres.forEach(g => {
          this.markers[g.id] = []
        })
        this.places.forEach(p => {
          const marker = new this.google.maps.Marker({
              position: {
                  lat: p.location.latitude, lng: p.location.longitude
              },
              title: String(p.id),
              map: this.map,
              icon: this.icon(p),
              zIndex: this.zIndex(p),
              visible: this.getVisible(p.genreIds)
          })
          this.google.maps.event.addListener(marker, "click", () => {
            this.$store.dispatch('map/updateSpotMarkerList', [])
            this.onMarkerSelected(p)
          })
          this.markers[p.genreIds[0]].push(marker)
        })
        this.genres.forEach(g => {
          if (this.getTextColor(g.id) !== undefined) {
              this.setPlaceMarkerCluster(g.id, this.markers[g.id])
          }
        })
      }
    },
    setPlaceMarkerCluster: function (id, markers) {
      // マーカーの表示
      this.setMarkerVisible(markers)
      // マーカークラスターの定義
      const styles = [{
        url: require('@/assets/images/mapmarker/cluster_' + id + '.png'),
        height: 28,
        width: 28,
        anchorText: [0, 0],
        textColor: this.getTextColor(id),
        textSize: 12
      }]
      if (this.markerCluster[id]) {
        this.markerCluster[id].clearMarkers()
      }
      this.markerCluster[id] = new window.MarkerClusterer(this.map, markers.filter(m => m.getVisible()), {
          styles: styles,
          enableRetinaIcons: true,
          gridSize: 30
      })
      this.google.maps.event.addListener(this.markerCluster[id], 'click', (cluster) => {
        this.$store.dispatch('drawer/close')
        let clusterMarkers = []
        for (var i = 0; i < cluster.getMarkers().length; i++) {
          clusterMarkers.push(this.places.find(p => String(p.id) === cluster.getMarkers()[i].title))
        }
        clusterMarkers.sort((a, b) => {
          return a.name < b.name ? -1 : 1
        })
        this.$store.dispatch('map/updateSpotMarkerList', clusterMarkers)
        this.$store.dispatch('drawer/openSpotMarkerList')
      })
    },
    setMarkerVisible: function (markers) {
      for (let i = 0; i < markers.length; i++) {
        const p = this.places.find(p => String(p.id) == markers[i].title)
        if (this.getVisible(p.genreIds)) {
          markers[i].setVisible(true)
        } else if (this.isFavorite && this.favorites.indexOf(p.id) !== -1) {
          markers[i].setVisible(true)
        } else {
          markers[i].setVisible(false)
        }
      }
    },
    getTextColor: function (id) {
      switch (id) {
        default:
          return '#000000'
        }
    },
    setFilter: function () {
      this.genres.forEach(g => {
        if (this.markers[g.id] !== undefined) {
          this.setPlaceMarkerCluster(g.id, this.markers[g.id])
        }
      })
    },
    onMarkerSelected: function (place) {
      this.$store.dispatch('drawer/openPlace', { place: place, full: true })
      this.$store.dispatch('drawer/showButton')
    },
    icon: function (place) {
      if (this.google) {
        let size = new this.google.maps.Size(36, 36)
        if (this.selectedPlace && place.id === this.selectedPlace.id) {
          size = new this.google.maps.Size(62, 62)
        }
        return {
          url: this.iconPath(place),
          scaledSize: size
        }
      }
    },
    iconPath(place) {
      if (place.mapIcon !== undefined && place.mapIcon.length > 0) {
        return place.mapIcon
      } else if (this.$store.getters['genres/getMapIcon'](place) !== undefined && this.$store.getters['genres/getMapIcon'](place).filterIcon !== undefined) {
        return this.$store.getters['genres/getMapIcon'](place).filterIcon
      } else {
        return require('@/assets/images/place-24px.svg')
      }
    },
    zIndex(place) {
      if (place.priority !== undefined){
        return 50 - place.priority
      } else {
        return 1
      }
    },
    mapInitialized: function () {
      this.setMarker()
    }
  },
  computed: {
    ...mapGetters({
      map: 'googleMap/getMap',
      filter: 'user/getFilter',
      isFavorite: 'user/getFavorite',
      favorites: 'favorites/getFavorites',
      selectedPlace: 'drawer/getSelectedPlace',
      genres: 'genres/getAll',
      places: 'places/getPlaces',
    }),
    google: gmapApi
  },
  watch: {
    filter: {
      handler: function () {
        this.setFilter()
      },
      deep: true
    },
    isFavorite: {
      handler: function () {
        this.setFilter()
      },
      deep: true
    },
    google: function () {
      this.setMarker()
    },
    selectedPlace: function () {
      if (this.sectedPlaceId !== null) {
        const place = this.places.find(p => p.id == this.sectedPlaceId)
        const genreId = place.genreIds[0]
        if (this.markerCluster[genreId] !== undefined) {
          const marker = this.markers[genreId].find(m => m.title == String(this.sectedPlaceId))
          marker.setIcon(this.icon(place))
          this.markerCluster[genreId].addMarker(marker)
        }
      }
      if (_.isEmpty(this.selectedPlace)) {
        this.sectedPlaceId = null
      } else {
        const index = this.places.findIndex(place => place.id === this.selectedPlace.id)
        if (index !== -1) {
          this.sectedPlaceId = this.selectedPlace.id
          const genreId = this.selectedPlace.genreIds[0]
          if (this.markerCluster[genreId] !== undefined) {
            const marker = this.markers[this.selectedPlace.genreIds[0]].find(m => m.title == this.selectedPlace.id)
            this.markerCluster[genreId].removeMarker(marker)
            // マップ上に表示
            marker.setMap(this.map)
            // アイコンのサイズ変更
            marker.setIcon(this.icon(this.selectedPlace))
          }
        }
      }
    }
  }
}
</script>
